import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom/client'
import * as serviceWorker from './serviceWorker'
import loadPolyfills from 'polyfills'
import 'styles/style.sass'
import './index.css'
import 'react-loading-skeleton/dist/skeleton.css'

let root

const render = () => {
  const App = require('./App').default
  if (!root) {
    root = ReactDOM.createRoot(document.getElementById('root'))
  }
  root.render(<App />)
}

loadPolyfills().then(() => render())
serviceWorker.unregister()

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./App', render)
}
